import { ApiService } from '@b2b/common/services/api/types';
import { IInjectable, StateParams } from '@uirouter/angularjs';

export function MembershipDataResolver(): IInjectable {
  return [
    '$stateParams',
    'ApiService',
    function ($stateParams: StateParams, ApiService: ApiService) {
      return ApiService.membership.detail($stateParams.id);
    },
  ];
}
